<template>
  <coozzy-card :title="$t('message.marketingSettings.applicationDossier.title')">
    <b-card-sub-title>
      {{ $t('message.marketingSettings.applicationDossier.subTitle') }}
    </b-card-sub-title>
    <div
      v-if="loading"
      class="row">
      <div class="col text-center">
        <coozzy-spinner />
      </div>
    </div>
    <template v-else>
      <div class="row">
        <div class="col-12 mt-3">
          <coozzy-form-checkbox
            :initial="requireDebtCollectionExtract"
            :disabled="readOnly"
            @change="requireDebtCollectionExtract = $event">
            {{ $t('message.marketingSettings.applicationDossier.debtCollectionExtract') }}
          </coozzy-form-checkbox>
        </div>
        <div class="col-12 mt-3">
          <coozzy-form-checkbox
            :initial="requireIdDocument"
            :disabled="readOnly"
            @change="requireIdDocument = $event">
            {{ $t('message.marketingSettings.applicationDossier.idDocument') }}
          </coozzy-form-checkbox>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <coozzy-button
            v-if="isCompanyAdmin"
            design="primary"
            class="float-right"
            @click="saveClicked">
            {{ $t('message.generic.form.save') }}
          </coozzy-button>
        </div>
      </div>
    </template>
  </coozzy-card>
</template>

<script>
import CoozzyCard from '@/framework/components/card/CoozzyCard'
import CoozzyFormCheckbox from '@/framework/components/form/checkbox/CoozzyFormCheckbox'
import CoozzyButton from '@/framework/components/button/CoozzyButton'
import CoozzySpinner from '@/framework/components/misc/CoozzySpinner'
import { user } from '@/mixins/user'
import Vue from 'vue'
import { loadReferenceCheckSettings, saveReferenceCheckSettings } from '@/settings/marketing/referenceCheckSettings'

export default {
  name: 'ApplicationDossierSettings',
  components: {
    CoozzySpinner,
    CoozzyButton,
    CoozzyFormCheckbox,
    CoozzyCard
  },
  mixins: [user],
  data() {
    return {
      loading: false,
      requireDebtCollectionExtract: false,
      requireIdDocument: false
    }
  },
  computed: {
    readOnly() {
      return !this.isCompanyAdmin
    }
  },
  mounted() {
    this.loadSettings()
  },
  methods: {
    loadSettings() {
      this.loading = true
      loadReferenceCheckSettings(this.accountId, this.currentLanguage)
        .then(settings => {
          this.requireDebtCollectionExtract = settings.requireDebtCollectionExtract
          this.requireIdDocument = settings.requireIdDocument
        })
        .catch(() => {
          Vue.toasted.show(this.$t('message.loadingErrors.generic'), { type: 'error' })
        })
        .finally(() => {
          this.loading = false
        })
    },
    saveClicked() {
      this.loading = true
      saveReferenceCheckSettings(this.accountId, this.currentLanguage, {
        requireDebtCollectionExtract: this.requireDebtCollectionExtract,
        requireIdDocument: this.requireIdDocument
      }).then(() => {
        Vue.toasted.show(this.$t('message.marketingSettings.applicationDossier.savedSuccessfully'), { type: 'success' })
      }).catch(() => {
        Vue.toasted.show(this.$t('message.marketingSettings.applicationDossier.savedFailed'), { type: 'error' })
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>
